function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlSpace: "preserve",
  viewBox: "0 0 47.5 47.5",
  role: "img"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 38h38V0H0z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  transform: "matrix(1.25 0 0 -1.25 0 47.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 6 6s6 6 12 0 0-12 0-12l-8-8s-6-6-12 0c-1.125 1.125-1.822 2.62-1.822 2.62l3.353 3.348S-.604-9.396 1-11c0 0 3-3 6 0l8 8s3 3 0 6-6 0-6 0L5.271-.729S3.417.792-.375-.375z",
  style: {
    fill: "#8899a6",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(16 28)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-6-6s-6-6-12 0 0 12 0 12l8 8s6 6 12 0c1.125-1.125 1.822-2.62 1.822-2.62L.469 8.031S.604 9.396-1 11c0 0-3 3-6 0l-8-8s-3-3 0-6 6 0 6 0L-5.271.729S-3.417-.791.375.375z",
  style: {
    fill: "#8899a6",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(21.845 10)"
})));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/share/ic-copy-link.svg";
export { SvgComponent as ReactComponent };